import type { ComponentType } from "react";
import BroadsheetLayout from "./layouts/BroadsheetLayout";
import GridLayout from "./layouts/GridLayout";
import MagazineLayout from "./layouts/MagazineLayout";
import TabloidLayout from "./layouts/TabloidLayout";
import EditorialMinimalLayout from "./layouts/EditorialMinimalLayout";
import type { LayoutKey, LayoutProps, Theme, CategoryKey } from "./types";

export const LAYOUTS: Record<LayoutKey, ComponentType<LayoutProps>> = {
  broadsheet: BroadsheetLayout,
  grid: GridLayout,
  magazine: MagazineLayout,
  tabloid: TabloidLayout,
  "editorial-minimal": EditorialMinimalLayout,
};

export function getLayout(key: string | null | undefined): ComponentType<LayoutProps> {
  if (key && key in LAYOUTS) return LAYOUTS[key as LayoutKey];
  return BroadsheetLayout;
}

export const FALLBACK_THEME: Theme = {
  palette: {
    bg: "#fafaf7",
    surface: "#ffffff",
    ink: "#0f0f0f",
    muted: "#5a5a55",
    rule: "#d4d2cb",
    accent: "#c14a2b",
    accentInk: "#ffffff",
  },
  typography: {
    masthead: "'Playfair Display', Georgia, serif",
    headline: "'Playfair Display', Georgia, serif",
    body: "'Lora', Georgia, serif",
    meta: "'Inter', system-ui, sans-serif",
  },
  ornaments: { rule: "thin", masthead: "plain", letterspacing: "normal" },
  density: "comfortable",
};

export function normalizeTheme(input: unknown): Theme {
  if (!input || typeof input !== "object") return FALLBACK_THEME;
  const obj = input as Partial<Theme>;
  return {
    palette: { ...FALLBACK_THEME.palette, ...(obj.palette ?? {}) },
    typography: { ...FALLBACK_THEME.typography, ...(obj.typography ?? {}) },
    ornaments: { ...FALLBACK_THEME.ornaments, ...(obj.ornaments ?? {}) },
    density: obj.density ?? FALLBACK_THEME.density,
  };
}

export const CATEGORY_LABELS_FR: Record<CategoryKey, string> = {
  "actualites-generales": "Actualites generales",
  "actualites-locales": "Actualites locales",
  "business-finance": "Business et finance",
  "culture-magazine": "Culture et magazine",
  sport: "Sport",
};

export const CATEGORY_LABELS_EN: Record<CategoryKey, string> = {
  "actualites-generales": "General news",
  "actualites-locales": "Local news",
  "business-finance": "Business and finance",
  "culture-magazine": "Culture and magazine",
  sport: "Sport",
};

export const ALL_CATEGORIES: CategoryKey[] = [
  "actualites-generales",
  "actualites-locales",
  "business-finance",
  "culture-magazine",
  "sport",
];

export type { LayoutKey, LayoutProps, Theme, CategoryKey } from "./types";
